const MaterialQuickSelect = () => {
  return <></>
}

export default MaterialQuickSelect
